import { Component, Input } from '@angular/core';
import { StrideSectionReportData, Skill } from '@mira-avant/mtlibs';
import { AngularModule } from '../../../../../../modules/angular.module';
import { SkillService } from '../../../../../../services/skill.service';

@Component({
	selector: 'app-class-breakdown',
	standalone: true,
	imports: [AngularModule],
	templateUrl: './class-breakdown.component.html',
	styleUrl: './class-breakdown.component.scss',
})
export class ClassBreakdownComponent {
	@Input('report') public report: StrideSectionReportData | undefined;
		public sortedSkills:Skill[] = [];

	constructor(private skillService:SkillService) {
		this.skillService.getSkills$().then((skills:Skill[]) => {
			this.sortedSkills = skills;
		});
	}
}
